/* ai-answer-loading-dialog.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ai-answer-loading-dialog.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { Fragment, Suspense, useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box } from '@atlaskit/primitives/compiled';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { messages } from '../../messages';
import { useAIAnswerContext } from '../ai-answer-context';
import { AIAnswerContentWarningAndBrandSection } from '../ai-answer-footer/ai-answer-footer';
import { onAIAnswerLoadingDialogShown } from '../analytics';
import { Collapse } from '../smart-answer-card/collapse';
import { NLPSearchResultFormat } from '../types';
import { AIAnswerLoadingStream } from './ai-answer-loading-stream';
import GeneratingAnimation from './generating-animation';
import { AIAnswerSearchLoadingBorder, GeneratingContainer, GeneratingText } from './styled';
var styles = {
  scroll: "_c71l1w81 _ca0qpxbi _18m91wug _1reo15vq _a5o91vhh"
};
// Used in quicksearch/advanced search
export var AIAnswerLoadingDialog = function AIAnswerLoadingDialog(_ref) {
  var collapsed = _ref.collapsed,
    toggleCollapsedState = _ref.toggleCollapsedState,
    callbacks = _ref.callbacks;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent;
  useEffect(function () {
    fireAnalyticsEvent(onAIAnswerLoadingDialogShown(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(LegacySmartAnswerLoadingDialog, {
    collapsed: collapsed,
    toggleCollapsedState: toggleCollapsedState,
    callbacks: callbacks
  });
};
var LegacySmartAnswerLoadingDialog = function LegacySmartAnswerLoadingDialog(_ref2) {
  var _ref2$collapsed = _ref2.collapsed,
    collapsed = _ref2$collapsed === void 0 ? true : _ref2$collapsed,
    toggleCollapsedState = _ref2.toggleCollapsedState,
    callbacks = _ref2.callbacks;
  var _useAIAnswerContext2 = useAIAnswerContext(),
    partialResponse = _useAIAnswerContext2.partialResponse,
    queryReasoning = _useAIAnswerContext2.queryReasoning,
    isReadingAids = _useAIAnswerContext2.isReadingAids,
    onClose = _useAIAnswerContext2.onClose;
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_sain_reasoning_exp'
    }),
    serveSAINReasoningExperiment = _getFrontendExperimen.serveExperiment;
  var isQuickSearch = Boolean(!isReadingAids && onClose);
  if (!partialResponse || (partialResponse === null || partialResponse === void 0 ? void 0 : partialResponse.format) !== NLPSearchResultFormat.MARKDOWN) {
    return /*#__PURE__*/React.createElement(AIAnswerSearchLoadingBorder, {
      isStreaming: false
    }, /*#__PURE__*/React.createElement(GeneratingContainer, null, /*#__PURE__*/React.createElement(GeneratingAnimation, null), /*#__PURE__*/React.createElement(GeneratingText, null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_generating_rovo))), /*#__PURE__*/React.createElement(AIAnswerContentWarningAndBrandSection, null));
  }
  if (isQuickSearch) {
    return /*#__PURE__*/React.createElement(AIAnswerSearchLoadingBorder, {
      isStreaming: true
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(Fragment, null)
    }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.scroll
    }, /*#__PURE__*/React.createElement(AIAnswerLoadingStream, {
      markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/React.createElement(AIAnswerContentWarningAndBrandSection, null))));
  }
  return /*#__PURE__*/React.createElement(AIAnswerSearchLoadingBorder, {
    isStreaming: true
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(Collapse, {
    collapsed: collapsed,
    isLoading: true,
    isStreaming: true,
    expandWhenClickedAnywhere: true,
    toggleCollapsedState: toggleCollapsedState,
    callbacks: callbacks
  }, /*#__PURE__*/React.createElement(AIAnswerLoadingStream, {
    markdown: partialResponse.partialNlpResult
  })), /*#__PURE__*/React.createElement(AIAnswerContentWarningAndBrandSection, null))));
};